var map = {
	"./notice-modal-de-DE.png": "bf71",
	"./notice-modal-en-US.png": "03d1",
	"./notice-modal-es-ES.png": "56b7",
	"./notice-modal-fr-FR.png": "18c3",
	"./notice-modal-ja-JP.png": "03ce",
	"./notice-modal-ko-KR.png": "5df6",
	"./notice-modal-pt-PT.png": "38a3",
	"./notice-modal-vi-VN.png": "38b8",
	"./notice-modal-zh-CN.png": "a6aa",
	"./notice-modal-zh-TW.png": "74ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6886";